/**
* Nom : ptuTypeRoleList.js
* Description : Ce fichier contient la définition de la page ptuTypeRoleList 
*               Cette page liste les roles des types de PTU
* Date de création : 27 aout 2026
*/

/* CSS et assets */
import { AddIcon } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { TabRD } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { Item } from 'package_ui_ihm/dist'
import { InputFormSide } from 'package_ui_ihm/dist'
import Divider from '@mui/material/Divider';

/* Hook */
import { useState, useEffect } from 'react';
import { useBlocker } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* PtuTypeRoleList : affiche la page qui liste les roles des types de PTU
*                     un lien permet d'afficher un formulaire pour créer un nouveau role
*
* Type : page 
*
* Parametres : 
*  None
*/
function PtuTypeRoleList() {

  // Define useState hooks

  const [ptuTypeRoles, setPtuTypeRoles] = useState([])
  const [statusPtuTypeRole, setStatusPtuTypeRole] = useState(null)
  const [isDataLoading, setDataLoading] = useState(false)
  const [isCreation, setCreation] = useState(false)
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState(false);
  const [isFormClicked, setFormClicked] = useState(false);


  // Define useContext hooks
  const { authStatus, authToken } = useAuth();
  const { path } = useApi();


  // Define useBlocker hooks
  const shouldBlock = isCreation;
  const blocker = useBlocker(shouldBlock);


  // Define useScreenWidth hooks
  const screenWidth = useScreenWidth();


  // Define functions
  async function retrieveData() {
    // Token
    const token = "Bearer " + authToken
    // PTU Types Roles
    const resPtuTypeRole = await fetch(path + "/api/eq-pttr/", 
      {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            accept: 'application/json',
            Authorization: token,
        },
      }
    );
    const dataPtuTypeRole = await resPtuTypeRole.json();
    setStatusPtuTypeRole(resPtuTypeRole["status"])
    setPtuTypeRoles(dataPtuTypeRole["results"])
    // Dataloading
    setDataLoading(false)
  }

  const handleClick = (event) => {
    event.preventDefault();
    setCreation(true)
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormClicked(true)
    if(name === null || name === ''){
      setNameError(true)
    }
    else
    {   
      setNameError(false)
    }
  };

  const handleReset = (event) => {
    event.preventDefault();
    setCreation(false)
    setName('')
    setNameError(false)
  };

  async function sendData(name) {
    // Token
    const token = "Bearer " + authToken
    // Retrieve treatment-type details
    await fetch(path + "/api/eq-pttr/", 
      {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: token,
        },
        body: JSON.stringify({
            "name": name
        })
      }
    );
    setCreation(false)
    setName(null)
    retrieveData()
    setFormClicked(false)
  }


  // Define useEffect hooks
  useEffect(() => {
    if(authStatus === 200)
    {
      setDataLoading(true)
      retrieveData()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if(nameError === false && isFormClicked === true){
      sendData(name)
    } else {
      setFormClicked(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameError, isFormClicked])

  useEffect(() => {
      // Bloquer la fermeture d'onglet/rafraîchissement
      const handleBeforeUnload = (e) => {
      if (shouldBlock === true) {
          // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
          e.preventDefault();
          e.returnValue = "";
          // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
          return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
      }
      }; 

      window.addEventListener("beforeunload", handleBeforeUnload);

      // Nettoyer l'écouteur quand le composant est démonté
      return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldBlock]);

  useEffect(() => {
      if (blocker.state === "blocked") {
          const confirmed = window.confirm(
              "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
          );

          if (confirmed) {
              blocker.proceed();
          } else {
              blocker.reset();
          }
      }
  }, [blocker]);


  // Render component
  return (
    <div>
      <TabRD tabNumber={4}/>
      <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
        <Container>
          {isDataLoading ? (
            <p>Chargement des données</p>
          ) : (
            (statusPtuTypeRole === 200) ? (
              <div>
                <h1>Roles des types de PTU</h1>
                <div className={(screenWidth > 650) ? 'grid-1-3' : null}>
                  {/*New*/}
                  <div className='flex-column'>
                    <div className='link' onClick={handleClick}>
                      <img src={AddIcon} alt='add_item_icon' className='link-img' />
                      <div className='link-text'>Role</div>
                    </div>
                    {(isCreation === true) ? (
                      <div className='flex-rows'>
                        <h3>Nouveau type</h3>
                        <form onSubmit={handleSubmit} onReset={handleReset} className='flex-column'>
                          <div className='flex-column form-center'>
                            <InputFormSide error={nameError} type="text" label="Nom" value={name} setValue={setName}/>
                          </div>
                          <div className='flex-row form-center'>
                            <button type="reset" className='button'>Annuler</button>
                            <button type="submit" className='button'>Valider</button>
                          </div>
                        </form> 
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                  {(screenWidth > 650) ? null : <Divider/>}
                  {/*PtuTypeRole list*/}
                  <div className='scroll-list-rd'>
                    <h2 className='subtitle'>Nombre de roles : {ptuTypeRoles.length}</h2>
                    {(ptuTypeRoles && ptuTypeRoles.length !== 0) ? (
                      ptuTypeRoles.sort((a, b) => (a.name > b.name)?1:-1).map((role) => (
                        <Item key={role['id']} id={role['id']}>
                          <div className='grid-1-1'>
                            <h3 className='item-text'>{role['name']}</h3> 
                          </div>
                        </Item>
                      ))
                    ) : (
                      <p>Aucun role actuellement. Veuillez en créer un !</p>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <h1>Connexion failed</h1>
            )
          )}
        </Container>
      </div>
    </div>
  );
}

export default PtuTypeRoleList;
